import {S21SrComponent} from "./S21SrComponent";


export function S21SrScreen() {
  return (<>
    <S21SrComponent/>
  </>)
}
